import { Typography } from '@mui/material';
import configs from '../../conf/config';

const Version = () => (
  <Typography variant="body2" color="textSecondary" align="center">
    {`Version ${configs.version}`}
    {'.'}
  </Typography>
);

export default Version;
